var map = {
	"./arrow-back.svg": 2,
	"./arrow-footer.svg": 3,
	"./arrow-right.svg": 4,
	"./arrow.svg": 5,
	"./certified-ribbon.svg": 6,
	"./dop.svg": 7,
	"./download.svg": 8,
	"./dropdown-arrow.svg": 9,
	"./file.svg": 10,
	"./layers.svg": 11,
	"./sample.svg": 12,
	"./search.svg": 13,
	"./water-protection.svg": 14
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1;